export const HEADERS = [
  'HEADER.ID',
  'HEADER.TITLE',
  'HEADER.DESCRIPTION',
  'HEADER.EXPIRATION_DATE',
  'HEADER.SPOTLIGHT_TYPE',
  'HEADER.CREATED',
];
